import { all, call, put, takeEvery } from 'redux-saga/effects';
import { get } from 'lodash';
import { notification } from 'antd';
import { LOAD_PREFERRED_SITE_LIST, LOCATIONS } from '../type';
import {
  loadPreferredSiteListSuccessAction,
  loadPreferredSiteListErrorAction,
} from '../action';
import { preferredSiteService } from 'services';
import MessengerResource from 'common/resource/MessengerResource';

function* handleLoadPreferredSiteList(action) {
  const location =
    action?.payload?.filter?.location || LOCATIONS.WESTERN_AUSTRALIA;
  try {
    const callback = get(action, 'payload.callback');
    const response = yield call(
      preferredSiteService.getPreferredSiteList,
      action.payload,
    );

    callback && callback(response);
    yield put(loadPreferredSiteListSuccessAction({ response, location }));
  } catch (error) {
    notification.error({
      message: MessengerResource.preferredSite.loadListError,
      description: error.message,
    });
    yield put(loadPreferredSiteListErrorAction({ error, location }));
  }
}

export function* loadPreferredSiteList() {
  yield takeEvery(LOAD_PREFERRED_SITE_LIST, handleLoadPreferredSiteList);
}

export default function* rootSaga() {
  yield all([loadPreferredSiteList()]);
}
